import moment from "moment";
import { Box, Text, VStack, useBreakpointValue } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import MobileHeader from "@/components/molecules/MobileHeader";
import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";
import { ClientTypeEnum } from "@/interfaces/domain/Client";

import { ProfileScreenProps } from "./types";

const ProfileWeb = ({ user, client, onCancel, onPressEdit }: ProfileScreenProps) => {
  const isCompany = client.tipo === ClientTypeEnum.B2B;
  const paddingX = useBreakpointValue({
    base: "1/5",
    xl: "1/4",
    "2xl": "1/3",
  });
  return (
    <Container px={paddingX} Header={<SimpleWebHeader />}>
      <Box py="4">
        <MobileHeader title="Dados Pessoais" onBackPress={onCancel} showLogo={false} />
      </Box>
      <VStack space="2" justifyContent="space-between">
        <Box>
          <Text fontSize="md">{isCompany ? "Nome fantasia" : "Nome"}</Text>
          <Text fontSize="lg" fontWeight="medium">
            {client.nome}
          </Text>
        </Box>
        {isCompany && (
          <>
            <Box>
              <Text fontSize="md">Razão social</Text>
              <Text fontSize="lg" fontWeight="medium">
                {client.razao_social}
              </Text>
            </Box>
            <Box>
              <Text fontSize="md">CNPJ</Text>
              <Text fontSize="lg" fontWeight="medium">
                {client.cnpj}
              </Text>
            </Box>
          </>
        )}
        <Box>
          <Text fontSize="md">Telefone</Text>
          <Text fontSize="lg" fontWeight="medium">
            {client.telefone || "-"}
          </Text>
        </Box>
        {!isCompany && (
          <Box>
            <Text fontSize="md">Data de nascimento</Text>
            <Text fontSize="lg" fontWeight="medium">
              {client.data_nascimento ? moment(client.data_nascimento).format("DD/MM/YYYY") : "-"}
            </Text>
          </Box>
        )}
        <Box>
          <Text fontSize="md">E-mail</Text>
          <Text fontSize="lg" fontWeight="medium">
            {user.email}
          </Text>
        </Box>
        <Box pt="24">
          <FormButton onPress={onPressEdit}>Editar</FormButton>
          <FormButton
            colorScheme="white"
            textColor="primary.700"
            my="4"
            shadow="2"
            onPress={onCancel}>
            Cancelar
          </FormButton>
        </Box>
      </VStack>
    </Container>
  );
};

export default ProfileWeb;
